<template>
  <div class="login" :style="{minHeight: bodyHeight}">
    <div class="login-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "host-login",
  data () {
    return {
      bodyHeight: "800px"
    };
  },
  computed: {
    year () {
      return new Date().getFullYear();
    }
  },
  created () {
    document.title = '主办登录';
    this.bodyHeight = window.innerHeight ? window.innerHeight + "px" : "800px";
    document.getElementsByTagName("body")[0].className = "h-100";
    document.getElementsByTagName("html")[0].className = "h-100";
  },
  methods: {},
  destroyed () {
    document.body.removeAttribute("class", "h-100");
    document.getElementsByTagName("html")[0].className = "";
  }
};
</script>
 
<style scoped lang="scss">
.login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
//   background: url(./img/bg.jpg);
  background: #fff;
  background-repeat: no-repeat;
  background-size: cover;
  &-header {
    width: 100%;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 74px 0 68px;
    &-r p {
      width: 48px;
      height: 24px;
      font-size: 24px;
      line-height: 18px;
      color: #ededed;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &-content {
    width: 100%;
    flex: 1;
    align-items: center;
    position: relative;
    &-footer {
      width: 100%;
      height: 51px;
      position: absolute;
      bottom: 31px;
      color: #000;
      font-weight: bold;
      font-size: 16px;
      .s1 {
        height: 30px;
      }
      .s1 {
        height: 21px;
      }
      .s1,
      .s2 {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
